import React from 'react';
import Icon from './Icon';

const FactoryIcon = (props) => (
    <Icon {...props}>
        <path d="M4 6h16v12H4z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 2v4M16 2v4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 2c0-1 2-2 4-2s4 1 4 2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10h2M12 10h2M17 10h2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 13h2M12 13h2M17 13h2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 16h2M12 16h2M17 16h2" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default FactoryIcon;